// extracted by mini-css-extract-plugin
export default {"speculative-projects":"SpeculativeProjectsSection_speculative-projects__3I0Qy"};